import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function History() {
  return (
    <>
      <Navbar />
        <div>History</div>
      <Footer />
    </>

  )
}

export default History